import { render, staticRenderFns } from "./DigitalPasswordSignature.vue?vue&type=template&id=90c50a9e&scoped=true&"
import script from "./DigitalPasswordSignature.vue?vue&type=script&lang=js&"
export * from "./DigitalPasswordSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c50a9e",
  null
  
)

export default component.exports